var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5858 4.24234C17.3668 3.46129 17.3668 2.19496 16.5858 1.41391C15.8047 0.632863 14.5384 0.632863 13.7574 1.41391L8.5 6.67127L3.41421 1.58548C2.63316 0.804436 1.36683 0.804436 0.585786 1.58548C-0.195262 2.36653 -0.195262 3.63286 0.585786 4.41391L5.67157 9.4997L0.585787 14.5855C-0.195262 15.3665 -0.195262 16.6329 0.585787 17.4139C1.36684 18.195 2.63316 18.195 3.41421 17.4139L8.5 12.3281L13.7574 17.5855C14.5384 18.3665 15.8047 18.3665 16.5858 17.5855C17.3668 16.8044 17.3668 15.5381 16.5858 14.7571L11.3284 9.4997L16.5858 4.24234Z",
    fill: "#FF6B00"
  })));
};

export default __webpack_public_path__ + "static/media/close.4f51a7e8.svg";
export { SvgClose as ReactComponent };